<button
  type="button"
  class="trigger"
  [class.is-placeholder]="empty"
  ngpSelect
  [id]="effectiveId"
  [ngpSelectValue]="value()"
  [ngpSelectDisabled]="isDisabled()"
  [ngpSelectDropdownContainer]="resolvedDropdownContainer"
  [attr.aria-invalid]="errorState ? 'true' : null"
  (ngpSelectValueChange)="onValueChange($event)"
>
  <span class="trigger__label">{{ selectedLabel }}</span>
  <fa-icon
    class="trigger__invalid-icon"
    [icon]="faCircleExclamation"
    aria-hidden="true"
  ></fa-icon>
  <fa-icon class="trigger__chevron" [icon]="faChevronDown"></fa-icon>
</button>

<ng-template ngpSelectPortal>
  <div ngpSelectDropdown>
    @for (opt of contentOptions; track opt.value) {
      <button
        type="button"
        ngpSelectOption
        [ngpSelectOptionValue]="opt.value"
        [ngpSelectOptionDisabled]="opt.disabled"
      >
        <ng-container [ngTemplateOutlet]="opt.labelTemplate" />
      </button>
    }
  </div>
</ng-template>
